import logoElisa from './logo-elisa.svg';
import logoElisaSecondary from './logo-elisa-secondary.svg';

export default {
    elisa_menu_logo: logoElisa,
    elisa_logo_secondary: logoElisaSecondary,
};
